/**
 * Same mediaSecurity gate as Normal survey NotesAndImage:
 * - If locations exist, use the selected location's flag
 * - Otherwise use survey / survey_without_login.mediaSecurity
 */
export function isMediaSecurityEnabled(survey, locations = []) {
  const selectedLocationId = localStorage.getItem('location') || '';

  if (locations?.length) {
    const selectedLocation = locations.find(
      (location) => String(location?._id) === String(selectedLocationId),
    );
    return Boolean(selectedLocation?.mediaSecurity);
  }

  return Boolean(
    survey?.survey_without_login?.mediaSecurity ?? survey?.mediaSecurity,
  );
}
